@if ((brandingSettings$ | async); as brandingSetting) {
  <div id="main-content" role="main" tabindex="-1" class="page-wrapper">
    <app-toggle-side-bar [outsideControl]="helpControl$">
      @if (questions() === 'doctor') {
        <app-doctor-questions [brandingSettings]="brandingSetting"></app-doctor-questions>
      }
      @if (questions() === 'patient') {
        <app-patients-questions [brandingSettings]="brandingSetting"></app-patients-questions>
      }
    </app-toggle-side-bar>
    <div class="page-side">
      <app-branded-header [brandingSettings]="brandingSetting" [profileType]="questions()" (helpClicked)="helpControl$.next(true)">
      </app-branded-header>
      <ng-content></ng-content>
      <app-footer></app-footer>
    </div>
  </div>
}
